<div>
  <app-page-breadcrumb pageTitle="Buttons" />
  <div class="space-y-5 sm:space-y-6">
    <!-- Primary Button  -->
    <div>
      <app-component-card title="Primary Button">
        <div class="flex items-center gap-5">
          <app-button size="sm" variant="primary"> Button Text </app-button>
          <app-button size="md" variant="primary"> Button Text </app-button>
        </div>
      </app-component-card>
    </div>
    <!-- Primary Button with Start Icon -->
    <div>
      <app-component-card title="Primary Button with Left Icon">
        <div class="flex items-center gap-5">
          <app-button size="sm" variant="primary" [startIcon]="boxIcon">
            Button Text
          </app-button>
          <app-button size="md" variant="primary" [startIcon]="boxIcon">
            Button Text
          </app-button>
        </div>
      </app-component-card>
    </div>
    <!-- Primary Button with Start Icon -->
    <div>
      <app-component-card title="Primary Button with Right Icon">
        <div class="flex items-center gap-5">
          <app-button size="sm" variant="primary" [endIcon]="boxIcon">
            Button Text
          </app-button>
          <app-button size="md" variant="primary" [endIcon]="boxIcon">
            Button Text
          </app-button>
        </div>
      </app-component-card>
    </div>
    <!-- Outline Button -->
    <div>
      <app-component-card title="Secondary Button">
        <div class="flex items-center gap-5">
          <!-- Outline Button -->
          <app-button size="sm" variant="outline"> Button Text </app-button>
          <app-button size="md" variant="outline"> Button Text </app-button>
        </div>
      </app-component-card>
    </div>
    <!-- Outline Button with Start Icon -->
    <div>
      <app-component-card title="Outline Button with Left Icon">
        <div class="flex items-center gap-5">
          <app-button size="sm" variant="outline" [startIcon]="boxIcon">
            Button Text
          </app-button>
          <app-button size="md" variant="outline" [startIcon]="boxIcon">
            Button Text
          </app-button>
        </div>
      </app-component-card>
    </div>
    <!-- Outline Button with Start Icon -->
    <div>
      <app-component-card title="Outline Button with Right Icon">
        <div class="flex items-center gap-5">
          <app-button size="sm" variant="outline" [endIcon]="boxIcon">
            Button Text
          </app-button>
          <app-button size="md" variant="outline" [endIcon]="boxIcon">
            Button Text
          </app-button>
        </div>
      </app-component-card>
    </div>
  </div>
</div>
